/**
 * Utilitário para lidar com erros do ResizeObserver
 * Este erro é comum em aplicações React com Material-UI e não afeta a funcionalidade
 */

// Suprimir o erro ResizeObserver que é um problema conhecido
const originalConsoleError = console.error;
const resizeObserverErrorPattern = 'ResizeObserver loop completed with undelivered notifications';

console.error = (...args: any[]) => {
  // Verifica se é o erro específico do ResizeObserver
  const errorString = args[0]?.toString?.() || args[0]?.message || '';
  if (errorString.includes(resizeObserverErrorPattern)) {
    // Suprime este erro específico
    return;
  }
  
  // Para todos os outros erros, chama o console.error original
  originalConsoleError.apply(console, args);
};

// Handler global para erros não capturados
window.addEventListener('error', (event) => {
  if (event.message?.includes(resizeObserverErrorPattern) || 
      event.error?.message?.includes(resizeObserverErrorPattern)) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
  return true;
});

// Handler para promises rejeitadas
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || event.reason?.toString?.() || '';
  if (errorMessage.includes(resizeObserverErrorPattern)) {
    event.preventDefault();
    return false;
  }
  return true;
});

// Polyfill do ResizeObserver para evitar erros em navegadores antigos
if (!window.ResizeObserver) {
  (window as any).ResizeObserver = class ResizeObserver {
    observe() {}
    unobserve() {}
    disconnect() {}
  };
}

export {};
